import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";

import MDTypography from "common/components/MD/MDTypography";


// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";

//prop-types is a library for typechecking of props
// Data

import DefaultInfoCard from "common/components/implemented/Cards/InfoCards/DefaultInfoCard";
import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import { Alert, AppBar } from "@mui/material";
import MDAlert from "common/components/MD/MDAlert/MDAlert";
import UtilityService from "services/API/utility/UtilityService";
import AuthService from "services/API/Auth/AuthService";

import { useFarFieraUIController } from "common/context/FarFieraContext";




function ContrattoVis() {


  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione} = ffcontroller;
 
 const navigate = useNavigate();
  const [part, setPart] = useState({
});

const stringa=  (<MDBox><MDTypography
variant="button"
fontWeight="regular"
color="text"
sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
Dopo aver accettato il Regolamento Tecnico di Quartiere,
Stampa il contratto e ricaricalo firmato in tutti i suoi punti   </MDTypography>
<MDButton  ml={3} onClick={() =>   navigate("/regolamento_tecnico")} color="success">Vai</MDButton>

</MDBox>);

const[contratto,setContratto]=useState(stringa);


useEffect(() => {
      
  seleziona_soggetto();

}, [manifestazione]);

async function seleziona_soggetto() {
  console.log("Cambiata pp->seleziono i dettagli :"+manifestazione);

      const response = await ExpoPartecipazioniService.seleziona_partecipazione(manifestazione);
    
    if(response){
      if(response.errors){
      console.log ("ERRORE:::");
       console.log(response.errors);
       setPart(null);
      }else{ retrive(response.data);

      }}else{
  console.log ("ERRORE:::");
    
       setPart(null);


      }
 
}
function retrive(data) {
    console.log(data);


  setPart({
      idPartecipazione: data.idPartecipazione,
      id_expo_richiesta:data.id_expo_richiesta,
      id_utente: data.id_utente,
      nome_pdf_contratto:data.nome_pdf_contratto,
      avi:data.avi,
  });

  console.log(":::"+data.nome_pdf_contratto);



  if(data.avi){
    setContratto(
<MDBox><MDTypography
variant="button"
fontWeight="regular"
color="text"
sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
 
Stampa il contratto e ricaricalo firmato in tutti i suoi punti   </MDTypography>
<MDButton  ml={3} onClick={() =>   navigate("/contratto")} color="success">Vai</MDButton>

</MDBox>);


  }
if(data.nome_pdf_contratto!=null && !data.nome_pdf_contratto==""){
  setContratto( (
    <MDTypography
      variant="button"
      fontWeight="regular"
      color="text"
      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
      onClick={() => vedi_contratto(data.idPartecipazione)}
    >
      {data.nome_pdf_contratto}
    </MDTypography>
  ));}
  console.log("selezionata  " + part.idPartecipazione);

}

async function vedi_contratto(idPartecipazione) {
  if (AuthService.isTokenOk()) {
  ExpoPartecipazioniService.download_pdf_contratto(idPartecipazione)
    .then(response => {

      return response.data;
    })
    .then(blob => {

      var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
      var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
      var url = URL.createObjectURL(blobb);
      var a = document.createElement('a');
      a.href = url;
      a.target = "_blank";

      a.download = "ContrattoAgriumbria.pdf";
      ;

      document.body.appendChild(a); // append the element to the dom
      a.click();
      a.remove(); // afterwards, remove the element  
    })
    .catch(error => {
      console.error(error);
    });


  }

}
async function download_pdf_avi() {
                  
  UtilityService.seleziona_file_man(manifestazione,"REGOLAMENTO_AVI")
      .then(response => {

          return response.data;
      })
      .then(blob => {

          var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
          var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
          var url = URL.createObjectURL(blobb);
          var a = document.createElement('a');
          a.href = url;
          a.target = "_blank";
          a.download ="RegolamentoAvi.pdf";
          document.body.appendChild(a); // append the element to the dom
          a.click();
          a.remove(); // afterwards, remove the element  
      })
      .catch(error => {
          console.error(error);
      });

}

async function download_pdf_rt() {
       
  if (AuthService.isTokenOk()) {
           
  UtilityService.seleziona_file_man(manifestazione,"R_TECNICO")
      .then(response => {

          return response.data;
      })
      .then(blob => {

          var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
          var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
          var url = URL.createObjectURL(blobb);
          var a = document.createElement('a');
          a.href = url;
          a.target = "_blank";
         
    
              a.download ="RegolamentoTecnicoDiQuartiere.pdf";
          document.body.appendChild(a); // append the element to the dom
          a.click();
          a.remove(); // afterwards, remove the element  
      })
      .catch(error => {
          console.error(error);
      });

    }


}
const regolamento_avi = (
    <MDButton variant="outlined" color="success"   onClick={download_pdf_avi} >
      Regolamento e Norme Sanitarie
    </MDButton>

);


const regolamento_tecnico = (
    <MDButton variant="outlined" color="success"   onClick={download_pdf_rt} >
      Regolamento Tecnico di Quartiere
    </MDButton>

);



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>

          <Grid item xs={12}>
                    {(part && part.idPartecipazione) &&
            <Card>
              <HeaderForm titolo={"I miei documenti per " + manifestazione} />
            
  
          
              <MDBox p={2}>
                  <MDAlert color ="success" >
                    Contratto di Partecipazione
                  </MDAlert>
                <DefaultInfoCard
                  color="success"
                  icon="drawicon"
                  title="Contratto"
                  description={part.avi ? "Il Contratto di Partecipazione a "+ manifestazione+" è da firmare e ricaricare":"Il Contratto di Partecipazione a "+ manifestazione+" è da firmare e ricaricare entro il 18 Gennaio 2026."}
                  value={contratto}
                />
              </MDBox>

              {!part.avi &&
              <MDBox p={2}>
              <MDAlert color ="success" >
                   Regolamento Tecnico di Quartiere
                  </MDAlert>
                
              <DefaultInfoCard
                    color="success"
                    icon="drawicon"
                    title={regolamento_tecnico}
                    description={"Scarica il regolamento tecnico"}
                    value=""
                  />
              </MDBox>}
                 {part.avi &&
              <MDBox p={2}>
              <MDAlert color ="success" >
                   Regolamento e Norme sanitarie
                  </MDAlert>
                
              <DefaultInfoCard
                    color="success"
                    icon="drawicon"
                    title={regolamento_avi}
                    description={"Scarica il regolamento"}
                    value=""
                  />
              </MDBox>}
               {!part.avi && <MDBox p={2}>
              <MDAlert color ="success" >
                   Promemoria per gli espositori
                  </MDAlert>
                  <DefaultInfoCard
                        
                        color="success"
                        icon="alarmOn"
                        title={<Link to="https://far.umbriafiere.it/download/promemoria.pdf" target="_blank">
                        <MDButton variant="outlined" color="success"  >
                          Promemoria per gli espositori
                        </MDButton>
                      </Link>}
                        description={"Promemoria importante per tutti gli espositori!"}
                        value=""
                      />
              </MDBox>}

            </Card>
            
            }
            
            {!part.idPartecipazione &&

  <Card>
              <HeaderForm titolo={"I miei documenti per " + manifestazione} />
              
                  <MDBox style={{ height: "200px" }} textAlign='center'>
                              <MDTypography
                                variant="button"
                                fontWeight="regular"
                                color="text"
                                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                              >
                               Non sei abilitato ad accedere a questa area!
                              </MDTypography></MDBox>
              </Card>
            }
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}



export default ContrattoVis;
